import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getOpenOrders, cancelOrder } from 'actions/EntityActions';
import Button from 'screens/components/basic/Button';
import Pagination from 'screens/components/basic/Pagination';
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import GenericTable from 'screens/components/advanced/GenericTable';
import LOOKUP from 'constants/lookup';
import TextInput from 'screens/components/basic/TextInput';
import DialogInput from 'screens/components/advanced/DialogInput';
import { Link } from 'react-router-dom';
import { formError, formInput, clearAdminOrderCancellation } from 'actions/FormActions';
import { showSnackbar, showError } from 'actions/CommonActions';
import util from 'library/util';

// Is this page still in use?
class OpenOrderList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activePage: 1,
            itemsPerPage: 25,
            dialogCancelOrder: false,
            selectedOrder: 0,
            orderNotes: null
        };
    }

    componentWillMount() {
        this.search();
    }

    componentWillReceiveProps(newProps) {
        // order cancelled
        if (this.props.posOrderCancelled !== newProps.posOrderCancelled && newProps.posOrderCancelled !== undefined && newProps.posOrderCancelled !== null) {
            if (newProps.posOrderCancelled === true) {
                this.closeDialogCancelOrder();
                this.search(1);
                this.setState({ activePage: 1 });
                this.props.showSnackbar(LOOKUP.openOrders.messages.cancelledMessage);
            }
            else {
                this.props.showError(LOOKUP.openOrders.messages.cancelledErrorMessage);
            }
            this.props.formInput(null, "posOrderCancelled");
        }
    }

    search = (page) => {
        this.props.getOpenOrders(this.props.branchId, page || this.state.activePage, this.state.itemsPerPage);
    }

    changePage = e => {
        this.setState({ activePage: e });
        this.props.getOpenOrders(this.props.branchId, e, this.state.itemsPerPage);
    }

    openDialogCancelOrder = (orderId, notes) => {
        this.props.clearAdminOrderCancellation();
        this.setState({ dialogCancelOrder: true, selectedOrder: orderId, orderNotes: notes });
    }

    closeDialogCancelOrder = () => {
        this.setState({ dialogCancelOrder: false, selectedOrder: 0, orderNotes: null });
    }

    cancelOrder = () => {
        const model = this.validateAndGetModel();
        if (model !== null) {
            this.props.cancelOrder(this.state.selectedOrder, model.notes);
        }
    }

    validateAndGetModel = () => {
        const p = this.props;
        const model = {
            id: this.state.selectedOrder,
            notes: p.notes
        };

        const validators = [
            ['openOrderCancellationNotes', model => model.notes !== '' && model.notes !== null && model.notes.length > 0, "Order Notes"]
        ];

        if (util.validate(validators, model, this.props.formError)) {
            return model;
        }

        return null;
    }

    render() {
        const p = this.props;
        const s = this.state;

        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li><Link to={LOOKUP.menu.admin.items.cashregister.link}>{LOOKUP.menu.admin.items.cashregister.text}</Link></li>
                    <li className="active">{LOOKUP.menu.admin.items.openOrders.text}</li>
                </ol>
                <h2>{LOOKUP.menu.admin.items.openOrders.text}</h2>
            </div>);

        const list = (this.props.openOrdersList).map((item, index) => {
            return {
                OrderId: item.id,
                Status: item.status,
                Date: item.createdDateString,
                Register: item.deviceName,
                Employee: `${item.employeeFirstName} ${item.employeeLastName}`,
                Patient: item.patientId === 0 ? 'Anonymous Patient' : `${item.patientFirstName} ${item.patientLastName}`,
                Total: `$ ${item.total.toFixed(2)}`,
                AmountPaid: `$ ${item.paid.toFixed(2)}`,
                NumberProducts: item.totalProducts,
                Icons: (
                    <div>
                        <Button
                            className="toggle-hidden hidden"
                            label="CANCEL"
                            primary={true}
                            onTouchTap={() => this.openDialogCancelOrder(item.id, item.comment)} />
                    </div>
                )
            };
        });

        return (
            <ContainerDivided headerContent={header}>
                <div className="form-group">
                    <GenericTable
                        tableBodyClassName="open-orders-table"
                        multiSelectable={false}
                        enableSelectAll={false}
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                        displayRowCheckbox={false}
                        selectable={true}
                        stripedRows={true}
                        columns={LOOKUP.openOrders.tableColumns}
                        rows={list} />

                    <Pagination
                        length={p.openOrdersListLength || 0}
                        itemsPerPage={s.itemsPerPage}
                        activePage={s.activePage}
                        onPageChange={(e) => this.changePage(e)} />
                </div>
                <DialogInput
                    title={LOOKUP.pos.cancellationDialog.title}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.closeDialogCancelOrder()} />,
                        <Button
                            key={2}
                            name="buttonRemoveItem"
                            label="Confirm"
                            primary={true}
                            onTouchTap={() => this.cancelOrder()} />]}
                    modal={true}
                    open={this.state.dialogCancelOrder}>
                    <div>
                        <div className="row">
                            <div className="col-lg-12" style={{ whiteSpace: 'pre-line' }}>
                                <p>Do you really want to cancel this order? To confirm it you must add a Comment for the order.</p>
                                <label>Order Notes: </label>
                                <p>{(!s.orderNotes || s.orderNotes.length === 0) ? "No notes for this order" : s.orderNotes}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <TextInput name={"openOrderCancellationNotes"}
                                    label="Notes"
                                    floatingLabelText="Notes"
                                    hintText="Notes"
                                    fullWidth={true} />
                            </div>
                        </div>
                    </div>
                </DialogInput>
            </ContainerDivided>
        );
    }
}

function mapStatetoProps(state) {
    return {
        openOrdersList: state.entity.openOrdersList,
        openOrdersListLength: state.entity.openOrdersListLength,
        notes: state.form.openOrderCancellationNotes,
        posOrderCancelled: state.form["posOrderCancelled"],
        branchId: state.common.branchId
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getOpenOrders: (branchId, page, itemsPerPage) => dispatch(getOpenOrders(branchId, page, itemsPerPage)),
        clearAdminOrderCancellation: () => dispatch(clearAdminOrderCancellation()),
        formError: (name, error) => dispatch(formError(name, error)),
        cancelOrder: (orderId, notes) => dispatch(cancelOrder(orderId, { notes: notes })),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(OpenOrderList);